// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Vna-z","updatedSizingPrediction":"Wna-z","recommendedSize":"Xna-z","predictedSize":"Yna-z","recommendedSizeCopy":"Zna-z"};